module.exports = __webpack_public_path__ + "static/media/sparkling-sabre.3a0fdc2b.svg";